import { render, staticRenderFns } from "./customerStatistics.vue?vue&type=template&id=68725a32&scoped=true&"
import script from "./customerStatistics.vue?vue&type=script&lang=js&"
export * from "./customerStatistics.vue?vue&type=script&lang=js&"
import style0 from "./customerStatistics.vue?vue&type=style&index=0&id=68725a32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68725a32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68725a32')) {
      api.createRecord('68725a32', component.options)
    } else {
      api.reload('68725a32', component.options)
    }
    module.hot.accept("./customerStatistics.vue?vue&type=template&id=68725a32&scoped=true&", function () {
      api.rerender('68725a32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataStatistics/components/customerStatistics.vue"
export default component.exports